import PropTypes from 'prop-types';

export const instagramDataPropType = PropTypes.shape({
  share_to_feed: PropTypes.bool,
});
